import { DosageDto, DosageSearchRequest, UpsertDosageDto } from 'ts-types/api.types';

import axios from './http';
import { CancelTokenSource } from 'axios';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/medicament-dosages`;

export const getAllDosages = (source: CancelTokenSource): Promise<Array<DosageDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then((response) => response.data);
};

export const searchDosages = async (dosageSearchRequest: Partial<DosageSearchRequest>,
                                    source: CancelTokenSource) => {

  return axios
      .post(`${apiUri}/search`, dosageSearchRequest, {cancelToken: source.token})
      .then(response => response.data);
};

export const findDosageById = (id: number, source: CancelTokenSource): Promise<UpsertDosageDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const addDosage = (upsertDosageDto: Partial<UpsertDosageDto>, source: CancelTokenSource): Promise<DosageDto> => {
  return axios
      .post(apiUri, upsertDosageDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editDosage = (id: number, upsertDosageDto: Partial<UpsertDosageDto>, source: CancelTokenSource): Promise<DosageDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertDosageDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const getAllMedicamentDosagesByMedicamentId = (medicamentId: number, source: CancelTokenSource): Promise<Array<DosageDto>> => {
  return axios
      .get(`${apiUri}`,{params: {medicamentId: medicamentId}, cancelToken: source.token})
      .then( response => response.data);
};

export const deleteDosage = (id: number, source: CancelTokenSource): Promise<DosageDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};
